import type { Step } from "react-joyride"
import PlannerStartStep from "../components/planner/planner-start"
import PlannerModifyObjectiveStep from "../components/planner/planner-modify-objective"
import PlannerMoveObjectiveStep from "../components/planner/planner-move-objective"
import StudyStartStep from "../components/study/study-start"
import StudyMoveActivityStep from "../components/study/study-move-activity"
import StudyDoActivityStep from "../components/study/study-do-activity"
import StudyChangeViewStep from "../components/study/study-change-view"
import StudyGoToSituationStep from "../components/study/study-go-to-situation"
import AgendaStartStep from "../components/agenda/agenda-start"
import AgendaCreateEventStep from "../components/agenda/agenda-create-event"
import AgendaEditEventStep from "../components/agenda/agenda-edit-event"
import MySituationStartStep from "../components/my-situation/my-situation-start"

export enum PRODUCT_TOUR_STEPS {
  AGENDA_START = "agenda-start",
  AGENDA_CREATE_EVENT = "agenda-create-event",
  AGENDA_EDIT_EVENT = "agenda-edit-event",
  PLANNER_START = "planner-start",
  PLANNER_MODIFY_OBJECTIVE = "planner-modify-objective",
  PLANNER_MOVE_OBJECTIVE = "planner-move-objective",
  STUDY_START = "study-start",
  STUDY_MOVE_ACTIVITY = "study-move-activity",
  STUDY_DO_ACTIVITY = "study-do-activity",
  STUDY_CHANGE_VIEW = "study-change-view",
  STUDY_GO_TO_MY_SITUATION = "study-go-to-my-situation",
  MY_SITUATION_START = "my-situation-start",
}

export const productTourSteps: Step[] = [
  {
    target: `#${PRODUCT_TOUR_STEPS.AGENDA_START}`,
    content: <AgendaStartStep />,
    placement: "center",
    disableBeacon: true,
  },
  {
    target: `#${PRODUCT_TOUR_STEPS.AGENDA_CREATE_EVENT}`,
    content: <AgendaCreateEventStep />,
    placement: "auto",
    disableBeacon: true,
    spotlightPadding: 5,
  },
  {
    target: `#${PRODUCT_TOUR_STEPS.AGENDA_EDIT_EVENT}`,
    content: <AgendaEditEventStep />,
    placement: "center",
    disableBeacon: true,
  },

  {
    target: `#${PRODUCT_TOUR_STEPS.PLANNER_START}`,
    content: <PlannerStartStep />,
    placement: "center",
    disableBeacon: true,
  },
  {
    target: `#${PRODUCT_TOUR_STEPS.PLANNER_MODIFY_OBJECTIVE}`,
    content: <PlannerModifyObjectiveStep />,
    disableBeacon: true,
    placement: "right",
  },
  {
    target: `#${PRODUCT_TOUR_STEPS.PLANNER_MOVE_OBJECTIVE}`,
    content: <PlannerMoveObjectiveStep />,
    disableBeacon: true,
    placement: "center",
  },
  {
    target: `#${PRODUCT_TOUR_STEPS.STUDY_START}`,
    content: <StudyStartStep />,
    placement: "center",
    disableBeacon: true,
  },
  {
    target: `#${PRODUCT_TOUR_STEPS.STUDY_MOVE_ACTIVITY}`,
    content: <StudyMoveActivityStep />,
    placement: "center",
    disableBeacon: true,
  },
  {
    target: `#${PRODUCT_TOUR_STEPS.STUDY_DO_ACTIVITY}`,
    content: <StudyDoActivityStep />,
    placement: "center",
    disableBeacon: true,
  },
  {
    target: `#${PRODUCT_TOUR_STEPS.STUDY_CHANGE_VIEW}`,
    content: <StudyChangeViewStep />,
    placement: "left",
    disableBeacon: true,
  },
  {
    target: `#${PRODUCT_TOUR_STEPS.STUDY_GO_TO_MY_SITUATION}`,
    content: <StudyGoToSituationStep />,
    placement: "left",
    disableBeacon: true,
    spotlightPadding: 5,
  },
  {
    target: `#${PRODUCT_TOUR_STEPS.MY_SITUATION_START}`,
    content: <MySituationStartStep />,
    placement: "center",
    disableBeacon: true,
  },
]
